import * as React from "react";
import { ComposerAttachment } from "../../../types";
import { Spinner, CloseIcon, FileGlyph, ImageGlyph } from "../../icons";
import styles from "./AttachmentChips.module.css";

/** Chip leading icon: spinner while uploading, else the kind's glyph. */
const chipIcon = (a: ComposerAttachment): React.ReactElement => {
	if (a.status === "uploading") return <Spinner className={styles.spinner} />;
	if (a.kind === "image") return <ImageGlyph />;
	return <FileGlyph />;
};

interface Props {
	attachments: ComposerAttachment[];
	onRemove?: (id: string) => void;
}

export const AttachmentChips: React.FC<Props> = ({ attachments, onRemove }) => {
	if (attachments.length === 0) return null;
	return (
		<div className={styles.row}>
			{attachments.map((a) => (
				<div key={a.id} className={styles.chip} data-status={a.status}>
					<span className={styles.icon}>{chipIcon(a)}</span>
					<span className={styles.name} title={a.name}>
						{a.name}
					</span>
					{onRemove && (
						<button
							type="button"
							className={styles.remove}
							aria-label={`Remove ${a.name}`}
							onClick={() => onRemove(a.id)}
						>
							<CloseIcon />
						</button>
					)}
				</div>
			))}
		</div>
	);
};
